export { StandaloneSearchBox } from './StandaloneSearchBox';
